/**
 * @description
 * Objeto webservice
 */

import { Wsdefs } from "./wsdefs.model";
import { Permissions } from "./permissions.model";

export class Webservice {
    public nifcif: string = "";
    public token: string = "";
    public tokenacces = "";
    public idioma: string = "";
    public codEmpresa: string = "";
    public wsdefs: Wsdefs[] = new Array<Wsdefs>();
    public permisos: Permissions[] = new Array<Permissions>();
    public rol: string = "";
    public dboid: string="";
    public userId: string="";
    constructor() {}
  
}